import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton";
import { DropdownField } from "../../../../shared/DropdownField";
import { DeactivateCustomerController } from "@njoy/controller";
import { CloseAccountModal } from "src/components/modals/closeAccountModal";
import ToastMessage from "src/hooks/useToast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as ROUTES from "../../../../../constants/routes";

export const CloseAccount: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState<string>("");

  const dropdownOptions = [
    { index: 1, label: "I have safety concerns" },
    { index: 2, label: "I had a poor service experience" },
    { index: 3, label: "Not interested anymore" },
    { index: 4, label: "Others" },
  ];

  return (
    <TemplateSub page="Close Account">
      <ToastContainer />
      
      <div className="px-[1rem]">
        <p className="text-[white] text-[16px] mt-[8px]">
          We're so sorry you're leaving. Please tell us why.
        </p>
        <div className="flex flex-col mt-[2rem] px-[1rem] bg-[#1E1E1E] rounded-xl overflow-hidden">
          <Formik
            initialValues={{ feedbackReason: null }}
            onSubmit={(values, { setErrors }) => {
              if (values.feedbackReason) {
                setReason(values.feedbackReason);
                setVisible(true);
              } else {
                setErrors({ feedbackReason: "Please provide a reason" });
              }
            }}
          >
            {({ values }) => (
              <Form className="w-full mt-10">
                <div className="flex flex-col">
                  {/* <label className="text-white text-sm mb-2">Please select a reason</label> */}
                  <Field
                    name="feedbackReason"
                    component={DropdownField}
                    options={dropdownOptions}
                    placeholder="Please select a reason"
                  />
                </div>

                <div className="p-2 mb-2 mt-4">
                  <NewButton
                    fullWidth
                    variant="primary"
                    type="submit"
                    className="login-form-button"
                  >
                    Proceed
                  </NewButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
          <DeactivateCustomerController>
          {({ submit }) => (
            <CloseAccountModal
              // history={props.history}
              // location={props.location}
              // match={props.match}
              visible={visible}
              onCancel={() => setVisible(false)}
              onOk={async () => {
                if (reason === "") return;
                const errors = await submit({ 
                  input: { reason }
                });

                if(errors) {
                  ToastMessage("error", errors.user || errors.deactivation || errors.wallet);
                }
             
                if(errors === null) {

                  window.location.replace(ROUTES.ACCOUNT_DETAILS);
                }
              }}
            />
          )}
        </DeactivateCustomerController>

      </div>
    </TemplateSub>
  );
};